import JustValidate from 'just-validate';

export default function initForms(){

	document.querySelectorAll('.mefa-checkbox').forEach(input => {
		input.addEventListener('keydown', (event) => {
			if (event.code === 'Space' || event.code === 'Enter') {
				event.target.querySelector("input").click();
			}
		});
	});

	const subscribeForms = document.querySelectorAll('.subscribe-form form');
	if (subscribeForms) {
		subscribeForms.forEach(form => {
			const validator = new JustValidate(form);
			const requiredInputs = form.querySelectorAll('[required]');
			requiredInputs.forEach(input => {
				validator.addField(input, [
					{
						rule: 'required',
						errorMessage: `${input.labels[0].textContent} is a required field`,
					},
				]);
				if (input.type === 'email') {
					validator.addField(input, [
						{
							rule: 'required',
							errorMessage: 'Email is a required field',
						},
						{
							rule: 'email',
							errorMessage: 'Please enter a valid email address',
						},
					]);
				}
			});

			form.querySelectorAll('#parent-phone').forEach(phoneField => {
				phoneField.addEventListener('change', (event) => {
					if(event.target.value != ""){
						validator.addField('#parent-authorize-checkbox', [
							{
								rule: 'required',
								errorMessage: 'Authorization is a required field',
							},
						]);
					}else{
						validator.removeField('#parent-authorize-checkbox');
					}
				})
			});
			form.querySelectorAll('#student-phone').forEach(phoneField => {
				phoneField.addEventListener('change', (event) => {
					if(event.target.value != ""){
						validator.addField('#student-authorize-checkbox', [
							{
								rule: 'required',
								errorMessage: 'Authorization is a required field',
							},
						]);
					}else{
						validator.removeField('#student-authorize-checkbox');
					}
				})
			});

			form.querySelectorAll('.grade-input').forEach((gradeInput) => {
				let select = gradeInput.querySelector('select');
				if(select){
					select.addEventListener('change', (event) => {
						if(!select.classList.contains('did-clone')){
							select.classList.add('did-clone');
							addAgeSelect(form.querySelector('.grade-input-next'), gradeInput, form, 2);
						}
					});
				}
			});
			validator.onSuccess((e) => {
				e.target.submit();
			});
		});
	}

	var addAgeSelect = (container, template, form, count) => {
		const clone = template.cloneNode(true);
		if(clone){
			container.appendChild(clone);

			let select = clone.querySelector('select');
			select.classList.remove('did-clone');
			select.name = `PreLead__c.S${count}_Formstack_Grade__c`;
			select.id = `PreLead__c.S${count}_Formstack_Grade__c`;
			let countString = count;
			if(count == 2){countString = "2nd";}
			if(count == 3){countString = "3rd";}
			if(count == 4){countString = "4th";}
			if(count == 5){countString = "5th";}
			if(count == 6){countString = "6th";}
			select.querySelector('option:checked').innerHTML = `Age or Grade of ${countString} Child`;

			select.addEventListener('change', (event) => {
				if(!select.classList.contains('did-clone')){
					const selects = document.querySelectorAll('.grade-input select');
					const lastSelect = selects[selects.length - 1];
					if (lastSelect.value != '' && selects.length < 6) {
						select.classList.add('did-clone');
						addAgeSelect(form.querySelector('.grade-input-next'), clone, form, selects.length+1);
					}
				}
			});
		}
	}

	//callback from formstack
	////https://help.formstack.com/s/article/Javascript-API
	window.FF_OnBeforeRender = () => {
		return true;
	}

	window.FF_OnAfterRender = () => {
		if(window.FFPostData){
			//prefill the form with the footer submitted data
			if(window.location.href.indexOf("sign-up-for-emails") !== -1){
				document.querySelector('#subscribe .container').style.display = 'none';
				let found = false;
				Object.entries(window.FFPostData).forEach(([key, value]) => {
					let modifiedKey = key.replace('PreLead__c_', 'PreLead__c.');
					const input = document.querySelector(`input[id="${modifiedKey}"]`);
					if (input) {
						input.value = value;
						if (input.type === 'checkbox' && value === 'on') {
							input.checked = true;
						}
						found = true;
					}
					const select = document.querySelector(`select[id="${modifiedKey}"]`);
					if (select) {
						select.value = value;
						found = true;
					}
					const span = document.querySelector(`span[id="${modifiedKey}"]`);
					if (span && span.getAttribute('role') === 'radio') {
						span.click();
						found = true;
					}
					if(modifiedKey == "PreLead__c.S2_Formstack_Grade__c" && value != ""){
						const selectElement = document.querySelector('select[id="FSGFCheckbox382"]');
						if(selectElement){
							selectElement.value = selectElement.options[0].value;
							selectElement.dispatchEvent(new Event('change'));
							found = true;
						}
					}
					if(modifiedKey == "PreLead__c.S3_Formstack_Grade__c" && value != ""){
						const selectElement = document.querySelector('select[id="FSGFCheckbox832"]');
						if(selectElement){
							selectElement.value = selectElement.options[0].value;
							selectElement.dispatchEvent(new Event('change'));
							found = true;
						}
					}
					if(modifiedKey == "PreLead__c.S4_Formstack_Grade__c" && value != ""){
						const selectElement = document.querySelector('select[id="FSGFCheckbox27"]');
						if(selectElement){
							selectElement.value = selectElement.options[0].value;
							selectElement.dispatchEvent(new Event('change'));
							found = true;
						}
					}
					if(modifiedKey == "PreLead__c.S5_Formstack_Grade__c" && value != ""){
						const selectElement = document.querySelector('select[id="FSGFCheckbox469"]');
						if(selectElement){
							selectElement.value = selectElement.options[0].value;
							selectElement.dispatchEvent(new Event('change'));
							found = true;
						}
					}
					if(modifiedKey == "PreLead__c.S6_Formstack_Grade__c" && value != ""){
						const selectElement = document.querySelector('select[id="FSGFCheckbox588"]');
						if(selectElement){
							selectElement.value = selectElement.options[0].value;
							selectElement.dispatchEvent(new Event('change'));
							found = true;
						}
					}
				});

				if(found){
					const captcha = document.querySelector('.ff-captcha');
					if (captcha) {
						setTimeout(() => {
							const captchaInput = captcha.querySelector('input');
							if (captchaInput) {
								captchaInput.focus();
							}
						}, 300);
					}
				}
			}
		}
	}

}
